import {
  createRouter,
  createWebHashHistory,
  createWebHistory,
  RouteRecordRaw,
} from "vue-router";
import Main from "@/views/Main.vue";
import VideoDetail from "@/views/videoDetail/VideoDetail.vue";
// const Main = () => import("@/views/Main.vue");
// const VideoDetail = () => import("@/views/videoDetail/VideoDetail.vue");
import Home from "@/views/home/Home.vue";
import Video from "@/views/video/Video.vue";
import Alone from "@/views/alone/Alone.vue";

import Playlist from "@/views/playlist/Playlist.vue";
import PlayListDetail from "@/views/playListDetail/PlayListDetail.vue";
import RankList from "@/views/rankList/RankList.vue";
import ArtistList from "@/views/artistList/ArtistList.vue";
import ArtistDetail from "@/views/artistDetail/ArtistDetail.vue";
import LatestMusic from "@/views/latestMusic/LatestMusic.vue";
import AlbumDetail from "@/views/albumDetail/AlbumDetail.vue";
import SearchContent from "@/views/searchContent/SearchContent.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/" || "/main",
    redirect: "/main/home",
  },
  {
    path: "/main",
    name: "main",
    component: Main,
    children: [
      {
        path: "/main/home",
        name: "home",
        component: Home,
      },
      {
        path: "/main/video",
        name: "video",
        component: Video,
      },
      {
        path: "/main/playlist",
        name: "playlist",
        component: Playlist,
      },
      {
        path: "/main/playlistdetail/:id",
        name: "playlistdetail",
        component: PlayListDetail,
      },
      {
        path: "/main/rankList",
        name: "rankList",
        component: RankList,
      },
      {
        path: "/main/artistList",
        name: "artistList",
        component: ArtistList,
      },
      {
        path: "/main/artistdetail/:id",
        name: "artistdetail",
        component: ArtistDetail,
      },
      {
        path: "/main/latestMusic",
        name: "latestMusic",
        component: LatestMusic,
      },
      {
        path: "/main/alone",
        name: "alone",
        component: Alone,
      },
      {
        path: "/main/albumdetail/:id",
        name: "albumDetail",
        component: AlbumDetail,
      },
      {
        path: "/main/searchContent/:id",
        name: "searchContent",
        component: SearchContent,
      },
    ],
  },
  {
    path: "/videodetail/:id",
    name: "videoDetail",
    component: VideoDetail,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
